module.exports = __webpack_public_path__ + "img/76.4f7d66a4.png";